import { Reducer } from 'redux';
import {
  WalletExpirationSettingsState,
  WalletExpirationSettingsTypes,
} from './types';

const INITIAL_STATE: WalletExpirationSettingsState = {
  walletExpirationSettingsData: {
    expirationType: 0,
    expirationDays: null,
  },
  loading: false,
  error: false,
};

const reducer: Reducer<WalletExpirationSettingsState> = (
  state = INITIAL_STATE,
  action,
) => {
  switch (action.type) {
    // GET WALLET EXPIRATION SETTINGS
    case WalletExpirationSettingsTypes.GET_WALLET_EXPIRATION_SETTINGS_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case WalletExpirationSettingsTypes.GET_WALLET_EXPIRATION_SETTINGS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        walletExpirationSettingsData: action.payload.walletExpirationSettingsData,
      };
    case WalletExpirationSettingsTypes.GET_WALLET_EXPIRATION_SETTINGS_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
      };

    // UPDATE WALLET EXPIRATION SETTINGS
    case WalletExpirationSettingsTypes.UPDATE_WALLET_EXPIRATION_SETTINGS_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case WalletExpirationSettingsTypes.UPDATE_WALLET_EXPIRATION_SETTINGS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        walletExpirationSettingsData: action.payload.walletExpirationSettingsData,
      };
    case WalletExpirationSettingsTypes.UPDATE_WALLET_EXPIRATION_SETTINGS_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
      };

    default:
      return state;
  }
};

export default reducer;
